import React, { useEffect, useRef } from 'react';
import {
  DownloadOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  SwapOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from '@ant-design/icons';
import { Image, message, Space } from 'antd';
import placeholder from '../../assets/images/profile_image_placeholder.png';
import { getRequest } from '../../helpers/apiCall';
const ImagePreview = ({ src }) => {
  src = src || placeholder;
  const onDownload = async () => {
    try {
      const resp = await getRequest('image-proxy', {
        image_url: src,
      });
      if(resp?.data?.success){
        const base64 = resp.data.base64;
        const matches = base64.match(/^data:(.+);base64,(.+)$/);
        if (!matches || matches.length !== 3) {
          throw new Error('Invalid base64 format');
        }
        const mimeType = matches[1];
        const byteCharacters = atob(matches[2]);
        const byteNumbers = new Array(byteCharacters.length)
          .fill(0)
          .map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = 'downloaded-image'; 
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      }
      else{
        message.error('Could not download image');
      }
    } catch (error) {
      message.error('Could not download image');
    }
  };
  
  
  return (
    <>
      <Image
        width={250}
        src={src}
     
        preview={{
          toolbarRender: (
            _,
            {
              transform: { scale },
              actions: { onFlipY, onFlipX, onRotateLeft, onRotateRight, onZoomOut, onZoomIn },
            },
          ) => (
            <Space size={12} className="image-preview toolbar-wrapper">
              <DownloadOutlined onClick={onDownload} color="#fff" />
              <SwapOutlined rotate={90} onClick={onFlipY} />
              <SwapOutlined onClick={onFlipX} />
              <RotateLeftOutlined onClick={onRotateLeft} />
              <RotateRightOutlined onClick={onRotateRight} />
              <ZoomOutOutlined disabled={scale === 1} onClick={onZoomOut} />
              <ZoomInOutlined disabled={scale === 50} onClick={onZoomIn} />
            </Space>
          ),
        }}
      />
    </>
  );
};
export default ImagePreview;
